import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import type { ScheduleLogRecord } from '~/types/responses';

import { offerQueryKeys } from './useGetOffer';

export function useGetScheduleLogs(offerId: string | undefined, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: offerQueryKeys.scheduleLogs(offerId),
    queryFn: async (): Promise<Array<ScheduleLogRecord>> => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      const response = await OffersService.getScheduleLogs(offerId, {});
      return response.logs;
    },
    enabled: enabled && !!offerId,
  });
}
